export function formatTitleCaseWords(value: string | null | undefined): string {
  const trimmedValue = value?.trim();

  if (!trimmedValue) {
    return '';
  }

  return trimmedValue
    .toLocaleLowerCase()
    .replace(/(^|[\s'-])(\S)/g, (_match, separator: string, character: string) => {
      return `${separator}${character.toLocaleUpperCase()}`;
    });
}

export function shouldFormatAsTitleCaseField(field: string | null | undefined): boolean {
  return field === 'country' || field === 'location';
}
